/*
 * @Date: 2020-07-14 14:04:47
 * @LastEditTime: 2020-12-30 14:30:13
 * @Description: main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

import 'normalize.css/normalize.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/styles/index.scss' //全局css
import '@/icons' //icon
import '@/permission.js'

let newAxios = axios.create({
  headers: {
    "Content-Type" :  'multipart/form-data'
  }
})
Vue.prototype.$axios = newAxios

Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')